import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const AddInvoiceLineItemMutation = graphql.persisted(
  "AddInvoiceLineItem",
  graphql(`
    mutation AddInvoiceLineItem($input: AddInvoiceLineItemInput!) {
      addInvoiceLineItem(input: $input) {
        lineItem { id description amountCents lineType }
        userErrors { message path }
      }
    }
  `)
);

export { AddInvoiceLineItemMutation };

export function useAddInvoiceLineItem() {
  return useMutation(AddInvoiceLineItemMutation);
}
